import { useFlags } from 'launchdarkly-react-client-sdk';

import { USE_EXTERNAL_TRIP_REQUESTS_FLAG } from '@/constants/feature-flagging';

/**
 * Reads the external trip requests feature flag.
 *
 * Gates whether the "Requests" feature surfaces (routes, sidebar item, global
 * search, member-app invitation, and the requests count) are shown for the
 * current organization. The flag is targeted per-org in LaunchDarkly via the
 * `orgResourceId` custom context attribute set in `ldClient.identify`.
 *
 * This does a plain read with no last-known-value retention: because the
 * flag is per-org, it must reflect the current LD context — holding a stale
 * value across an org switch would mis-gate the feature for the new org. An
 * absent/undefined flag coerces to `false` (fail-closed), which is the
 * desired default during the brief window after `identify()` while flags
 * stream in for the new context.
 *
 * @returns {boolean} true when external trip requests should be enabled
 */
const useExternalTripRequestsFlag = () => {
  const flags = useFlags();

  return Boolean(flags[USE_EXTERNAL_TRIP_REQUESTS_FLAG]);
};

export default useExternalTripRequestsFlag;
